
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"fill":"#F35325","d":"M1.852 1.852h9.722v9.722H1.852z"}}),_c('path',{attrs:{"fill":"#81BC06","d":"M12.426 1.852h9.722v9.722h-9.722z"}}),_c('path',{attrs:{"fill":"#05A6F0","d":"M1.852 12.426h9.722v9.722H1.852z"}}),_c('path',{attrs:{"fill":"#FFBA08","d":"M12.426 12.426h9.722v9.722h-9.722z"}})])])
          )
        }
      }
    